

import Config from "../Config";

import { useState, useRef } from "react";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputUploader(props)
{

    //tmpIn = <input type="file" name="fileselect[]"  accept="*/*" />
    
    
    const [typ,setTyp] = useState(props.typ);
    const [typId, setTypId] = useState(props.typId);
    const [remove, setRemove] = useState(props.remove);


    var cr = '';
    if(props.crypt != null && props.crypt != undefined) cr = props.crypt;
    const [crypt, setCrypt] = useState(cr);


    const [title, setTitle] = useState(props.title);
    const [maxFiles, setMaxFiles] = useState(props.max_files);
    const [ext, setExt] = useState(props.ext);

    const [progress, setProgress] = useState(-1);

   
    const inputFileRef = useRef( null );

    const [items,setItems] = useState([]);


    if(title != props.title) setTitle(props.title);
 

    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);

        if(props.completeUpload != undefined)
        {
            props.completeUpload(fileName, crypt);
            setProgress(-1);
        }
    }


    const goSelect = (e) => {

        setProgress(-2); // czekaj...

        inputFileRef.current.click();

        setItems([]);
    }

    const goUpload = (e) => {

        setProgress(-1); //

        if( e.target.files.length == 0) return false;     
        var files = e.target.files;

        console.log("files " + files);

        setProgress(-2); //trwa ladowanie..

        var it = [];
     
        for(var i = 0; i < files.length; i++) 
        {             
            var row = {
                file: files[i],
                name: files[i]['name'],
                type: files[i]['type'],
                progress: -1
            };

            it.push(row);
        }  
        
        setItems(it);

        //--------------------------

        const goSendFile = (num) => {

 
                if(num  >= it.length ) return;
                   
                   // var reader = new FileReader();
                   // reader.onload = function (e) 
                   // {
                       //e.target.result                                      
                   // };
        
                   var xhr = new XMLHttpRequest();
          
                   xhr.upload.addEventListener('progress',function(ev)
                    {        
                          var procent = (ev.loaded/ev.total );   
                          procent *= 100;
                          procent = Math.round(procent) ;
                          procent = (procent) ;
        
                          console.log("Progress " + procent);
                          setProgress(procent);
        
                     
         
                          
                    }, false);
        
        
                    xhr.addEventListener("load",  function(ev){
                        
                    
        
                  } , false);
        
        
                  xhr.addEventListener("error", function(ev){}, false);
                  xhr.addEventListener("abort", function(ev){}, false);
        
                  xhr.onreadystatechange = function(ev)
                  {                  
                        if (xhr.readyState == 4) 
                         {                                                                       
                               // alert(xhr.responseText);                                                                 
                                let json = JSON.parse(xhr.responseText);
        
                                if(json.status != undefined && json.status == 'OK')
                                {
                                        completeUpload( json.param.old_name, json.param.crypt );
                                }else
                                {
        
                                }
        
                                goSendFile(num+1);
                         }
                  };
        
        
                  xhr.open('POST',  Config.master + "/rest_v1,upload" , true);   
        
                  xhr.setRequestHeader('X-Api-Key', props.userData.apiKey);
                  xhr.setRequestHeader('_p_przedszkole_id_', props.userData.p_przedszkole_id);
                  xhr.setRequestHeader('_sec_key_', Config.genXKey() );

                  
        
                  var data = new FormData();           
                  data.append('typ',typ);
                  data.append("typ_id", typId);          
                  data.append('remove', remove);
                  data.append('crypt', crypt);
                  data.append('file'+num, it[num].file ); 
                  xhr.send(data);
        
        
               
            
        }
   
        goSendFile(0); //start..

       


    }



    var tmpIn = null;

    if(maxFiles == 1)
    {
        tmpIn = <input type="file" name="fileselect[]"  className="hide" accept={ext} onChange={goUpload} ref={inputFileRef} />
    }else
    {
        tmpIn = <input type="file" name="fileselect[]"  accept={ext}  className="hide" multiple  onChange={goUpload} ref={inputFileRef}/>
    }

    var tmpP = progress;
    if(tmpP == -2) 
    {
       // tmpP = "czekaj...";
       tmpP = "";
    }
    else
    if(tmpP == -1) 
    {
        tmpP = "";
    }
    else
    if(tmpP > 100 ) 
    {
        tmpP = "";
    }else
    if(tmpP == 100 ) 
    {
        tmpP = " czekaj... ";
    }else    
    {
        tmpP = tmpP +"%";
    }

    
    if(typ != props.typ)
    {
        setTyp(props.typ);
    }

    if(typId != props.typId)
    {
        setTypId(props.typId);
    }


    var defLink = "link_normal";
    if(props.className != undefined)  {
        defLink = props.className;
    }

    return (
        <div onClick={goSelect} className={defLink}>
            {title} &nbsp;
            <b>{tmpP}</b>
            {tmpIn}
                
         </div>
    )
}



export default InputUploader;